<template>
  <!-- 微信绑定 -->
  <el-dialog class="bind-wechat-dialog" top="15%" :title="$i18.language('申请开通')" :visible.sync="dialogOpen" :destroy-on-close="true" width="345px" :before-close="handleClose">
    <div class="showContent">
      <div class="customer-service" v-if="userInfo.customerService">
        <div style="margin-top: 10px; margin-left: 25px">
          <img v-if="userInfo.customerService.img" :src="userInfo.customerService.img" alt="" />
          <svg-icon v-else class="head" name="customer-service"></svg-icon>
        </div>
        <div class="info">
          <div class="hegnt">
            <span class="label">{{ $t('accountOverview.customerService') }}：</span>
            <span class="value">{{ userInfo.customerService.name ? userInfo.customerService.name : $t('nullData') }}</span>
          </div>
          <div class="row hegnt">
            <div>
              <span class="label">{{ $t('accountOverview.Tel') }}：</span>
              <span class="value">{{ userInfo.customerService.tel ? userInfo.customerService.tel : $t('nullData') }}</span>
            </div>
          </div>
          <div class="row hegnt">
            <div>
              <span class="label">{{ $t('accountOverview.Mobile') }}：</span>
              <span class="value">{{ userInfo.customerService.mobile ? userInfo.customerService.mobile : $t('nullData') }}</span>
            </div>
          </div>
          <div class="row hegnt" v-if="userInfo.customerService.email!=='-1'">
            <div>
              <span class="label">{{ $t('accountOverview.Email') }}：</span>
              <span class="value">{{ userInfo.customerService.email ? userInfo.customerService.email : $t('nullData') }}</span>
            </div>
          </div>
          <div class="rote hegnt hegnt-wechat">
            <div class="label">{{ $t('accountOverview.Enterprise') }}：</div>
            <!-- <div v-if="userInfo.customerService.weixin"><img id="imgwh"   align="left" :src="userInfo.customerService.weixin" alt="" /></div> -->
            <div><img class="imgwh-wechat" align="left" src="../../assets/qywx.png" alt="" /></div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
  
  <script>
export default {
  name: 'SouvueBindWechat',

  data() {
    return {
      dialogOpen: false,
    }
  },
  mounted() {},
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
  },
  created() {},
  methods: {
    handleClose() {
      this.dialogOpen = false;
      this.$emit('changeStatus')
    },
   
  },
}
</script>
  
<style lang="scss" scoped>
.customer-service {
  display: flex;
  .head {
    font-size: 40px;
  }

  .info {
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 12px;
    flex: 1;
  }
  .label {
    color: $--color-font-light;
  }
  .hegnt {
    margin-bottom: 12px;
  }
  .hegnt-wechat {
    display: flex;
    .imgwh-wechat {
      width: 82px;
      height: 82px;
      border-radius: none !important;
    }
  }
}
</style>
  